import { createStyles } from '@mantine/core'

export default createStyles(() => ({
  linkWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'left',
  },
  linkWrapperInner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'left',
    cursor: 'pointer',
    '&:hover': {
      opacity: 0.75,
    },
  },
  link: {
    color: '#b476eeff !important',
    fontSize: '18px',
    fontWeight: 'bold',
  },
  backLink: {
    display: 'inline-block',
    paddingLeft: '7px',
  },
  asianTextBlock: {
    whiteSpace: 'nowrap',
  },
}))
